import React, { useEffect, useState } from "react";
import * as style from "../../pages/ApplicationList/ApplicationList.module.scss";
import { Divider, TextInput } from "cprime-foundational-components";
import CprimeButton from "../Common/CprimeButton";

export interface VersionFormState {
  version: string;
  release_date: string;
  tag: string;
}

interface SaveVersionPayload extends VersionFormState {
  isEdit: boolean;
  baseVersion: string;
}

interface ManageCreateVersionProps {
  isEdit: boolean;
  baseVersion: string;
  formData: VersionFormState;
  onClose: () => void;
  onSave: (payload: SaveVersionPayload) => Promise<void>;
}

const ManageCreateVersion: React.FC<ManageCreateVersionProps> = ({
  isEdit,
  baseVersion,
  formData,
  onClose,
  onSave,
}) => {
  const scssClass = style as any;
  const [versionForm, setVersionForm] = useState<VersionFormState>(formData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVersionForm(formData);
  }, [formData]);

  const handleChange = (field: keyof VersionFormState, value: string) => {
    setVersionForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isUnchanged = () => {
    if (!isEdit) {
      return false;
    }

    return (
      versionForm.version.trim() === (formData.version || "").trim() &&
      versionForm.release_date.trim() ===
        (formData.release_date || "").trim() &&
      versionForm.tag.trim() === (formData.tag || "").trim()
    );
  };

  const isSaveDisabled =
    loading || !versionForm.version.trim() || (isEdit && isUnchanged());

  const handleSave = async () => {
    if (isSaveDisabled) {
      return;
    }

    setLoading(true);
    try {
      await onSave({
        isEdit,
        baseVersion,
        version: versionForm.version.trim(),
        release_date: versionForm.release_date.trim(),
        tag: versionForm.tag.trim(),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={scssClass.panelContent}>
        <Divider
          variant="fullWidth"
          sx={{
            marginBottom: "15px",
            width: "100%",
            marginLeft: "0px !important",
            backgroundColor: "#f8f8f9 !important",
          }}
        />

        <div className={scssClass.textDescription}>Version Details</div>

        <div className={scssClass.fieldsContent}>
          <div className={scssClass.firstRow}>
            <div className={scssClass.firstRowChild}>
              <TextInput
                value={versionForm.version}
                fullWidth
                onChange={(e: any) =>
                  handleChange("version", e?.target?.value || "")
                }
                placeholder="Input Text"
                label="Version"
                maxLength={100}
              />
            </div>
            {/* <div className={scssClass.firstRowChild}>
              <TextInput
                value={versionForm.release_date}
                fullWidth
                onChange={(e: any) =>
                  handleChange("release_date", e?.target?.value || "")
                }
                placeholder="YYYY-MM-DD"
                label="Release Date"
                maxLength={50}
              />
            </div> */}
          </div>

          {/* <div className={scssClass.secondRow}>
            <TextInput
              value={versionForm.tag}
              fullWidth
              onChange={(e: any) => handleChange("tag", e?.target?.value || "")}
              placeholder="Input Text"
              label="Tag"
              maxLength={100}
            />
          </div> */}
        </div>
      </div>

      <div className={scssClass.bottomPanel}>
        <Divider
          variant="fullWidth"
          sx={{
            marginBottom: "15px",
            width: "100%",
            marginLeft: "0px !important",
            backgroundColor: "#f8f8f9 !important",
          }}
        />
        <div className={scssClass.footerButtons}>
          <div></div>
          <div>
            <CprimeButton
              variant="tertiary"
              sx={{ marginRight: "10px" }}
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CprimeButton>
            <CprimeButton
              variant="primary"
              sx={{ marginLeft: "5px" }}
              onClick={handleSave}
              disabled={isSaveDisabled}
              loading={loading}
            >
              {isEdit ? "Save Version" : "Create Version"}
            </CprimeButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageCreateVersion;
